<template>
  <ul v-if="hasResults">
    <li v-for="result in results"
      :key="result.id"
      @click="selectResult(result)"
      @keyup:enter="selectResult(result)">
      <span>{{ setResultDisplayFormat(result) }}</span>
    </li>
  </ul>
</template>

<script>

import Types from '@/Mapper/CustomType';

export default {
  name: 'SearchResults',
  props: {
    results: {
      required: true,
    },
    searchType: {
      required: true,
      type: String,
      default: '',
    },
  },
  computed: {
    hasResults() {
      return this.results && this.results.length > 0;
    },
  },
  methods: {
    setResultDisplayFormat(result) {
      if (result) {
        const searchType = this.$helpers.strHasValue(result.searchType)
          ? result.searchType
          : this.searchType;
        switch (searchType) {
          case Types.Search.Lead:
            return `${result.leadinfo.firstname} ${result.leadinfo.lastname} - ${result.leadinfo.streetaddress} ${result.leadinfo.suburb.toUpperCase()}`;
          case Types.Search.Suburb:
            return `${result.suburb}, ${result.state} ${result.postcode}`;
          case Types.Search.Address:
            return `${result.address}`;
          case 'agency':
            console.log(result);
            return `${result.fullname}`;
          default:
            console.error(`Error in SearchResult component\rUnhandled search type action (${searchType})`);
            return '';
        }
      }
      console.error(`Error in SearchResult component\rresult is not an object (${result})`);
      return '';
    },
    selectResult(selectedResult) {
      this.$emit('selectedResult', selectedResult);
    },
  },
};
</script>

<style lang="scss" scoped>
  ul {
    @apply ut-overflow-auto  ut-absolute ut-w-full;
    border: 1px solid #ccc;
    max-height: 218px;
    border-radius: 0 0 4px 4px;
    background-color: #FFFFFF;
    margin-top: -3px;
    z-index: 2;

    li{
      @apply ut-py-1 ut-px-3 ut-cursor-pointer;
      font-size: 14px;
      letter-spacing: 0.26px;
      line-height: 24px;
      color: rgba(46,52,59,0.78);

      &:hover {
        background-color: #e6e6e6;
      }
    }

  }


</style>
